import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'typeface-lato';
import { HashRouter as Router } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Router>
      <ScrollToTop />
          <App />
        </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
